import { createIcon } from '../createIcon';
import { ReactComponent as IconCalendarAlt } from '../svg/calendar-alt.svg';

export default createIcon(IconCalendarAlt);
